export default __webpack_public_path__ + "static/media/party-shane.148ee90e.jpg";